// Complemento de adiantamento (reunião Inter 02/10).
// No "Novo adiantamento", um item que JÁ tem adiantamento (aguardando crédito ou creditado)
// pode ser selecionado de novo para pedir um complemento com valor livre — ex.: aéreo que
// subiu de 10.000 para 62.000. A API aplica as mesmas regras (OrcamentoController::solicitarAdiantamento).
// Adiantamento "não creditado" não se complementa: o caminho é Renegociar.

export const TIPO_COMPLEMENTO = 'novo';

export function itemLiberadoParaComplemento(item = {}, tipo) {
    return tipo === TIPO_COMPLEMENTO
        && !!item.temAdiantamento
        && !!item.adiantamentoInfo
        && !item.adiantamentoInfo.nao_creditado;
}

export function itemBloqueado(item = {}, tipo) {
    return !!item.temAdiantamento && !itemLiberadoParaComplemento(item, tipo);
}

// Contador "marcados/marcáveis" do fornecedor: conta todo item que dá para marcar no tipo escolhido —
// no "Novo adiantamento" isso inclui o item já adiantado (complemento). Antes contava só os livres e o
// complemento sumia da conta ("1/1" com 2 itens marcados).
export function contadorGrupo(itensGrupo = [], tipo) {
    const marcaveis = itensGrupo.filter((item) => !itemBloqueado(item, tipo));
    return { selecionados: marcaveis.filter((item) => item.selecionado).length, total: marcaveis.length };
}

export function selecaoEhComplemento(itens = [], tipo) {
    return itens.some((item) => item.selecionado && itemLiberadoParaComplemento(item, tipo));
}

// Mesmas recusas da API, para avisar antes do envio (botão desabilitado + mensagem).
export function pendenciasComplemento(itens = [], tipo) {
    const selecionados = itens.filter((item) => item.selecionado);
    const complemento = selecionados.filter((item) => itemLiberadoParaComplemento(item, tipo));
    if (complemento.length === 0) return [];
    const pendencias = [];
    if (complemento.length !== selecionados.length) {
        pendencias.push('Complemento: selecione só itens que já têm adiantamento. Os itens novos vão em outra solicitação.');
    }
    const titulos = new Set(complemento.map((item) => String(item.adiantamentoInfo?.titulo_id ?? '')));
    if (titulos.size > 1) {
        pendencias.push('Complemento: selecione itens de um mesmo adiantamento (um complemento por vez).');
    }
    return pendencias;
}

// 21/10 (Rafael): "só vai aparecer o valor que falta". Complemento = itens de UM adiantamento (mesmo grupo):
// falta = soma de todos os itens desse adiantamento − o que já foi pedido nele (original + complementos ativos,
// `adiantamentoInfo.valor_adiantado`). null quando não é complemento ou a API não manda o dado.
export function faltaDoComplemento(itens = [], tipo) {
    const complemento = itens.filter((item) => item.selecionado && itemLiberadoParaComplemento(item, tipo));
    if (complemento.length === 0) return null;
    const info = complemento[0].adiantamentoInfo || {};
    const grupo = info.grupo_titulo;
    if (grupo === undefined || grupo === null || info.valor_adiantado === undefined || info.valor_adiantado === null) return null;
    const somaDoAdiantamento = itens
        .filter((item) => String(item.adiantamentoInfo?.grupo_titulo ?? '') === String(grupo))
        .reduce((soma, item) => soma + (Number(item.valorPreEvento) || 0), 0);
    return Math.max(0, Math.round((somaDoAdiantamento - Number(info.valor_adiantado)) * 100) / 100);
}
